<template>
  <div>
    <ul style="display:none">
      <li :key="file.id" v-for="(file, index) in files">
        <span>{{file.name}}</span> -
        <span>{{file.size}}</span> -
        <span v-if="file.error">{{file.error}}</span>
        <span v-else-if="file.success">success</span>
        <span v-else-if="file.active">active</span>
        <span v-else-if="file.active">active</span>
        <span v-else></span>
      </li>
    </ul>
    <c-row>
      <c-col span="12">
        <span v-bind:key="action.action" v-for="action in properties">
          <c-row>
            <span class="u-mt-10">{{action.action}}</span>
          </c-row>
          <c-row>
            <c-col offset="2">
              <span v-bind:key="p.code" v-for="(p,index1) in action.properties">
                <c-form-field :help="p.description" :label="p.name" v-if="p.type === 'string'">
                  <c-form-input v-model="p.val"></c-form-input>
                </c-form-field>
                <c-form-field :help="p.description" :label="p.name" v-if="p.type === 'password'">
                  <c-form-input v-model="p.val" type="password" icon-end="icon-eye"></c-form-input>
                </c-form-field>
                <c-form-field :help="p.description" :label="p.name" v-if="p.type === 'file'">
                  <FormInputClick readonly v-model="p.display_val" iconEnd="icon-pencil" @iconclick="onEditProperty(index1)"></FormInputClick>
                  <div v-if="current_upload == index1"><file-upload
                    :data="data"
                    :headers="headers"
                    :input-id="p.code"
                    :multiple="false"
                    :post-action="postAction"
                    @input-file="inputFile"
                    @input-filter="inputFilter"
                    class="btn btn-primary"
                    extensions="xlsx,xlsm,xlsb,xls,jpg,json,bmp,jpeg,pdf,csv"
                    ref="upload"
                    v-model="files"
                  >
                    <i class="fa fa-plus"></i>
                    Select file
                  </file-upload>
                  <button @click.prevent="startUpload" class="btn btn-success" type="button">
                    <i aria-hidden="true" class="fa fa-arrow-up"></i>
                    Upload
                  </button>
                  <button @click.prevent="download" class="btn btn-success" type="button">
                    <i aria-hidden="true" class="fa fa-arrow-up"></i>
                    Download
                  </button>
                    </div>
                </c-form-field>
              </span>
            </c-col>
          </c-row>
        </span>
        <c-row>
          <span class="u-mt-10"></span>
        </c-row>
      </c-col>
      <c-col>
        <nav class="navbar">
          <div class="navbar__start"></div>
          <div class="navbar__end">
            <a @click="onConfirm" class="navbar__item" v-tooltip="'Write Changes'">
              <i class="icon-floppy-disk u-h4 u-color-success"></i>
              <span class="u-color-success u-ml-5">SAVE CHANGES</span>
            </a>
          </div>
        </nav>
      </c-col>
    </c-row>
  </div>
</template>
<script>
import axios from 'axios'
import FileUpload from 'vue-upload-component'
import FormInputClick from './FormInputClick'
import download from 'downloadjs'
import { mapState } from 'vuex'

const uuidv4 = require('uuid/v4')

export default {
  name: 'ClientEnvSettings',
  components: {
    FileUpload,
    FormInputClick
  },

  data () {
    return {
      properties: [],
      files: [],
      // display_val: '',
      current_upload: -1,

      postAction: process.env.API + 'upload/post/xxx',
      headers: {
        Authorization: 'Bearer xxx'
      },
      data: {
        _csrf_token: 'xxxxxx'
      },

      thread: 1,
      drop: true,
      dropDirectory: false,
      addIndex: true,
      uploadAuto: true,
      minSize: 1,
      size: 1024 * 1024 * 1024,
      editFile: {
        show: false,
        name: ''
      }
    }
  },

  computed: {
    ...mapState('auth', ['clientCode'])
  },

  created () {
    this.headers['Authorization'] = `Bearer ${this.$auth.getAccessToken()}`
    this.postAction = process.env.API + 'upload/post/yyy'

    this.fetchProperties()
  },

  methods: {
    onEditProperty (index) {
      this.current_upload = index
    },

    edit (index) {
      return `<i class="icon-pencil" onclick="onEditProperty(${index})"></i>`
    },

    fetchProperties () {
      let url = process.env.API + this.clientCode + '/env-properties'

      axios
        .get(url)
        .then(response => {
          this.properties = response.data
        })
        .catch(reason => {
          console.error('Could not get data')
          console.error(reason)
          this.$snotify.error('Error retrieving data', null, {
            position: 'centerTop',
            timeout: 3000,
            showProgressBar: false
          })
        })
    },
    onConfirm () {
      this.validateBeforeSubmit()
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then(result => {
        if (result) {
          // eslint-disable-next-line
          this.saveProperties();
        }
      })
    },
    saveProperties () {
      let url = process.env.API + this.clientCode + '/env-properties'

      axios
        .put(url, this.properties)
        .then(response => {
          // display a toast ...
          console.log(response.data)
          this.$snotify.success('Changes saved successfully', null, {
            position: 'centerTop',
            timeout: 3000,
            showProgressBar: false
          })
        })
        .catch(reason => {
          console.error('Could not save properties')
          this.globalError =
            'Unable to change password (old password does not match?)'
          this.$snotify.error('Could not save changes', null, {
            position: 'centerTop',
            timeout: 3000,
            showProgressBar: false
          })
        })
    },

    inputFilter (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },

    inputFile (newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        console.log('add', newFile)
        this.properties[0].properties[this.current_upload].display_val = newFile.name
        this.properties[0].properties[this.current_upload].val = uuidv4().replace(/-/g, '')
        // dirty hack...
        // this.display_val = this.properties[0].properties[0].display_val
        this.postAction =
          process.env.API + 'upload/properties/post/' + this.properties[0].properties[this.current_upload].val
        newFile.postAction = this.postAction
        console.log('uuid generated: ', this.properties[0].properties[this.current_upload].val)
      }
      if (newFile && oldFile) {
        // update
        console.log('update', newFile)
        if (!newFile.active) {
          if (newFile.success) {
            this.$snotify.success('File uploaded successfully', null, {
              position: 'centerTop',
              timeout: 3000,
              showProgressBar: false
            })
          } else {
            this.$snotify.error('File could not be uploaded', null, {
              position: 'centerTop',
              timeout: 3000,
              showProgressBar: false
            })
          }
        }
      }
      if (!newFile && oldFile) {
        // remove
        console.log('remove', oldFile)
      }
    },

    startUpload () {
      console.log('start upload')
      this.$refs.upload[0].active = true
    },

    download () {
      let url = process.env.API + this.clientCode + '/env-properties/' + this.properties[0].properties[this.current_upload].code + '/download'
      console.log('download property file - ' + url)

      axios
        .get(url, {
          responseType: 'blob'
        })
        .then(response => {
          download(response.data, this.properties[0].properties[this.current_upload].display_val)
        })
        .catch(reason => {
          console.error('Could not download file')
          console.error(reason)
          this.$alert({
            type: 'error',
            title: 'Could not download file',
            content:
                'The file you selected cannot be downloaded. It may have exceeded the retention period on the server or another error occured. You may want to contact the application administrators if you need more details.',
            showCancel: false,
            confirmText: 'Close'
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ClientSettings/EnvProperties.vue